export default __webpack_public_path__ + "static/media/IBC-13_2011_logo.c79fc03a.png";